// sortStoryboards sorts an array.  Gotcha: arrays are passed by reference.  To avoid infinite-loop pass a copy of array [...blah]
function sortStoryboards(storyboards) {
  if (storyboards.length <= 1) {
    return storyboards
  }

  /*
    Sort storyboards by:
    tall ones first, wide ones next, boxy ones last, such that if these are float:left the flow would be like
     _____    ______________________
    |     |  |                      |
    |     |  |______________________|
    |     |   ________    ________
    |     |  |        |  |        |
    |     |  |        |  |        |
    |     |  |________|  |________|
    |     |
    |_____|
  */

  // Calculate w:h ratios for all storyboards
  storyboards = storyboards.map(s => {
    if (s.width && s.height) {
      s.heightWidthRatio = s.height / s.width
    }
    return s
  })

  // Segregate storyboards
  const tallStoryboards = []
  const wideStoryboards = []
  storyboards.forEach(s => {
    if (s.heightWidthRatio > 1) {
      tallStoryboards.push(s)
    } else {
      wideStoryboards.push(s)
    }
  })

  // Sort tall storyboards by largest width
  tallStoryboards.sort((a, b) => (a.heightWidthRatio > b.heightWidthRatio ? 1 : -1))

  // Sort wide storyboards by smallest height
  wideStoryboards.sort((a, b) => (a.heightWidthRatio < b.heightWidthRatio ? 1 : -1))

  // Concat and return
  return [...tallStoryboards, ...wideStoryboards]
}

export default sortStoryboards
